import React, { useState, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'

const Select = ({
  options,
  value = null,
  onChange,
  disabled = false,
  placeholder = 'Select...'
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const [highlightedIndex, setHighlightedIndex] = useState(0)

  const containerRef = useRef(null)

  const handleSelectOption = (option) => {
    if (disabled) {
      return
    }

    onChange(option.value)
    setIsOpen(false)
  }

  const handleClickOutside = (e) => {
    if (containerRef.current && !containerRef.current.contains(e.target)) {
      setIsOpen(false)
    }
  }

  const handleOpenClose = () => {
    if (disabled) {
      return
    }

    if (isOpen) {
      setIsOpen(false)
    } else {
      setIsOpen(true)
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  useEffect(() => {
    console.log(document.body.scrollHeight)
    window.parent.postMessage({
      'frameHeight': document.body.scrollHeight
    }, "*")
  }, [isOpen])

  const getSelectedLabel = (val) => {
    const option = options.find(opt => opt.value === val)
    return option ? option.label : ''
  }

  const displayValue = () => {
    return value ? getSelectedLabel(value) : ''
  }

  return (
    <div className='relative flex-1' ref={containerRef}>
      <div
        className={
          `flex items-center min-w-[190px] h-[48px] border-[1px] px-[10px] py-[9px] ${disabled ? 'cursor-not-allowed border-[#D9D9D9]' : 'cursor-pointer border-black'}`
        }
        onClick={handleOpenClose}
      >
        <div className={`flex flex-1 flex-wrap items-center gap-2 text-base font-medium ${disabled ? 'text-[#D9D9D9]' : 'text-black'}`}>
          {value ? (
            displayValue()
          ) : (
            placeholder
          )}
        </div>
        <div className='ml-2 flex-shrink-0'>
          <svg
            className={`w-5 h-5 ${disabled ? 'text-[#D9D9D9]' : 'text-black'} transition-transform duration-200 ${isOpen ? 'transform rotate-180' : ''}`}
            xmlns='http://www.w3.org/2000/svg'
            fill='none'
            viewBox='0 0 24 24'
            stroke='currentColor'
          >
            <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M19 9l-7 7-7-7' />
          </svg>
        </div>
      </div>
      {isOpen && (
        <ul className='absolute z-50 w-full bg-white border border-gray-300 mt-1 max-h-48 overflow-y-auto'>
          {options.length > 0 ? (
            options.map((option, index) => {
              const isSelected = value === option.value
              return (
                <li
                  key={option.value}
                  className={`px-4 py-2 cursor-pointer flex items-center justify-between text-sm ${
                    index === highlightedIndex ? 'bg-[#062743] text-white' : ''
                  } ${isSelected ? 'bg-[#062743]/70 text-white' : ''}`}
                  onMouseEnter={() => setHighlightedIndex(index)}
                  onMouseDown={(e) => {
                    e.preventDefault()
                    handleSelectOption(option)
                  }}
                >
                  <span>{option.label}</span>
                  {isSelected && (
                    <svg 
                      className="w-4 h-4 text-white" 
                      fill="none" 
                      viewBox="0 0 24 24" 
                      stroke="currentColor"
                    >
                      <path 
                        strokeLinecap="round" 
                        strokeLinejoin="round" 
                        strokeWidth={2} 
                        d="M5 13l4 4L19 7" 
                      />
                    </svg>
                  )}
                </li>
              )
            })
          ) : (
            <div className='px-4 py-2 text-gray-500'>No options found</div>
          )}
        </ul>
      )}
    </div>
  )
}

Select.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.any.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string
}

export default Select